import Marquee from "react-fast-marquee";
import { usePerspective } from "@/context/PerspectiveContext";
import { getContent } from "@/content/perspectives";

const EditorialMarquee = () => {
  const { perspective } = usePerspective();
  const items = getContent(perspective).marquee;
  return (
  <div
    data-testid="marquee"
    className="border-y border-black/10 bg-[#f5f7fb] py-8 lg:py-10"
  >
    <Marquee speed={38} gradient={false} autoFill>
      {items.map((item) => (
        <span key={item} className="mx-8 flex items-center gap-16 lg:mx-12">
          <span className="font-serif text-4xl italic text-cobalt lg:text-6xl">
            {item}
          </span>
          <span className="text-cobalt/30 lg:text-5xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
  );
};

export default EditorialMarquee;
